import { parsePhoneNumber } from "libphonenumber-js";

/**
 * Format a phone number to be more user-friendly using libphonenumber-js.
 * Automatically detects country and formats accordingly.
 *
 * Examples:
 * - "+4917631673122" → "+49 176 31673122"
 * - "+41782429891" → "+41 78 242 9891"
 * - "+12125551234" → "+1 212 555 1234"
 */
export function formatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return phoneNumber;

  try {
    // Parse the phone number (works with international format)
    const parsed = parsePhoneNumber(phoneNumber);

    if (parsed) {
      // Return international format with proper spacing
      return parsed.formatInternational();
    }
  } catch (error) {
    // If parsing fails, return original number
    console.warn("Failed to parse phone number:", phoneNumber, error);
  }

  // Fallback: return original if parsing fails
  return phoneNumber;
}
